export const animationZeroLengthDurationTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('RuntimeError') !== -1 && desyncdata.indexOf('being called repeatedly with a zero-length duration') !== -1) {
			return {
				type: 'animationZeroLengthDurationTest',
				color: 'Goldenrod',
				title: 'Animation Zero Length Duration Error',
				text: 'An issue with animation states system.',
				description: 'An interaction is continuously playing an animation and preventing the game from properly performing.<br/>The best action is to save, turn the game off and try playing again.'
			}
		}
	}
}

// EXAMPLE
/*

*/


// WEBPACK FOOTER //
// ./src/tests/basegame/animationZeroLengthDurationTest.js